package com.xtream.composeapp.viewmodel


import androidx.lifecycle.ViewModel
import com.xtream.data_kmp.PreferencesRepo
import com.xtream.data_kmp.dto.TMDBMovieImages
import com.xtream.data_kmp.remote.createApiService
import com.xtream.data_kmp.util.extension.addTMDBPrefixImageURL
import io.ktor.client.call.body
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update


class TmdbViewModel(
    private val preferencesRepo: PreferencesRepo,
) : ViewModel(){

    private val _movieLogo = MutableStateFlow<String?>(null)
    val movieLogo = _movieLogo.asStateFlow()


    //TODO move loads to repo

    suspend fun loadMovieLogo(tmdbId:String?){



        try {
            val tmdbKey: String? =  preferencesRepo.getPref( PreferencesRepo.SERVER_TMDB_KEY)
            if (tmdbId == null) throw Exception("No TMDB ID")
            /*val client = HttpClient(OS.Android) {
                if (Build.VERSION.SDK_INT <= Build.VERSION_CODES.N) {
                    engine {
                        sslManager = { httpsURLConnection ->
                            httpsURLConnection.sslSocketFactory =
                                KtorSslHelper.getUnsafeSSLSocketFactory()
                            httpsURLConnection.hostnameVerifier = HostnameVerifier { _, _ -> true }
                        }
                    }
                }
                install(Logging) {
                    if (BuildConfig.DEBUG) {
                        logger = object : Logger {
                            override fun log(message: String) {
                                Log.d("KtorLog", message)
                            }
                        }
                        level = LogLevel.ALL // FULL detail: headers + bodies + method + URL}
                    }
                }
                install(ContentNegotiation) {


                    json(kotlinx.serialization.json.Json {
                        ignoreUnknownKeys = true
                        isLenient = true
                        encodeDefaults = false

                        explicitNulls = false

                    })
                }

            }*/
            val apiService = createApiService("")
            val response = apiService.getTmdbMovieLogo( tmdbId)
            //println("++++ ${response}")
            val tmdbLogoURl=  response.body<TMDBMovieImages>().logos?.let {
                val logo= it.firstOrNull {itm->itm?.iso6391?.lowercase()=="en" }?: it.firstOrNull()
                logo?.filePath?.addTMDBPrefixImageURL()
            }

            if (tmdbLogoURl == null) throw Exception("No TMDB Logo")
            _movieLogo.update { tmdbLogoURl }
        }catch (e:Exception){
            _movieLogo.update { null }
        }

    }
}